import type { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const AdvisorKeys = {
	all: ["advisor"] as const,
	list: () => [...AdvisorKeys.all, "list"] as const,
	detail: (id: string) => [...AdvisorKeys.all, "detail", id] as const,
	agentDetail: (id: number | undefined) =>
		[...AdvisorKeys.all, "agent", "detail", id ?? null] as const,
	assignedAgents: (filterStatus?: UserAgentStatusEnum) =>
		[...AdvisorKeys.all, "agent", "assigned", { filterStatus }] as const,
};
